export const iconFontAwesomeGendersVenusDouble = (
	<i className="fa-solid fa-venus-double"></i>
);
